// Copyright (C) 2023 Graz University of Technology.
//
// invenio-records-lom is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

import TRANSLATE_DE from "./de/translations.json";
import TRANSLATE_EN from "./en/translations.json";

export const translations = {
  de: { translation: TRANSLATE_DE },
  en: { translation: TRANSLATE_EN },
};
